<template>
  <div class="body-box marginBox">
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addAdvertise">新增广告</el-button>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 20px)'" :data="advertiseList" class="button-box">
      <el-table-column label="内容" prop="content"></el-table-column>
      <el-table-column label="小程序路径" prop="page"></el-table-column>
      <el-table-column label="类型" prop="enumType">
        <template slot-scope="scope">
          {{scope.row.enumType | advertiseType}}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="enumEnable">
        <template slot-scope="scope">
          {{scope.row.enumEnable === 'NORMAL' ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editAdvertise(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeAdvertiseById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync='queryInfo' @pagination="getAdvertiseList" /></div>

    <addAdvertise @refresh-list="handleQuery" ref="addAdvertise"></addAdvertise>
    <editAdvertise @refresh-list="handleQuery" ref="editAdvertise"></editAdvertise>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addAdvertise from '@/views/advertise/addAdvertise'
import editAdvertise from '@/views/advertise/editAdvertise'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteAdvertise, getAdvertiseList } from '@/api/advertise/advertise'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, Pagination, addAdvertise, editAdvertise },
  data() {
    return {
      queryInfo: {
        keyword: ''
      },
      advertiseList: []
    }
  },
  mounted() {
    this.handleQuery()
  },
  methods: {
    //查询列表
    getAdvertiseList(page, cb) {
      getAdvertiseList(page).then((response) => {
        this.advertiseList = cb(response)
      })
    },

    //根据ID删除数据
    removeAdvertiseById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAdvertise(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //新增
    addAdvertise() {
      this.$refs.addAdvertise.addDialog()
    },

    //修改
    editAdvertise(row) {
      this.$refs.editAdvertise.editDialog(row)
    },

    //查询按钮
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    }

  }
}
</script>

<style lang="less" scoped>

</style>
